import React from 'react';

import DevelopCard from 'screens/Profile/DevelopCard';
import styled from 'styled-components';
import { StyledBox } from 'styles/common';

import TasksGoalsContainer from '../TasksGoalsContainer';

const FullHeightBox = styled(StyledBox)`
  height: 100%;
`;

const Competencies = ({ employee }) => (
  <TasksGoalsContainer>
    <FullHeightBox flexcontainer justifycontent="flex-start" alignitems="stretch" flexdirection="column">
      <DevelopCard employee={employee} showEndorseComponent={false} showHeader={false} includeMiscellaneous />
    </FullHeightBox>
  </TasksGoalsContainer>
);

export default Competencies;
